var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticStyle:{"position":"absolute","height":"0","width":"0"}},[_c('filter',{attrs:{"id":_vm.filterId}},[_c('feConvolveMatrix',{ref:"convolveMatrix",attrs:{"order":_vm.dimension,"kernelMatrix":_vm.kernel}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }